import { useContext } from 'react';
import { ProductTableContext } from '../../contexts/product-table-context';
import { DisplayQuantityToggle } from '../quantity-toggle';

export function DisplayInCasesToggle() {
  const { filters, setFilters } = useContext(ProductTableContext);
  const { displayInCases } = filters;

  return (
    <DisplayQuantityToggle
      displayInCases={displayInCases || false}
      setDisplayInCases={(displayInCases) => setFilters({ ...filters, displayInCases })}
    />
  );
}
